import { render } from "./YearPicker.vue?vue&type=template&id=94610754&ts=true"
import script from "./YearPicker.vue?vue&type=script&lang=ts"
export * from "./YearPicker.vue?vue&type=script&lang=ts"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__